import { useParams } from "react-router-dom";
import parse from 'html-react-parser';
import store from "../../../_services/store";
import { BackButton, Image } from "../../_ui";
import { Container } from "./components";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { useWindowResize } from "../../../_hooks/use-window-resize";


const ArticlePage = observer(() => {
  const { id } = useParams();
  const { width } = useWindowResize();
  const currentWidth = width - 50 < 400 ? width - 50 : 400;

  useEffect(() => {
    if(id){
      store.getArticlesForID(+id);
    }
    
  }, [])
  
  const sections = store.articleDetails?.sections?.map((section: { photos: any[]; is_conetent_first: string; content: string; }, i: number) => {
    const photos = section.photos.map(photo =>
      <div key={`photo_${photo.label}`} style={{ marginBottom: '20px' }}>
        <Image src={photo.label} width={`${currentWidth}px`} height="auto" />
        <legend>{photo.legend}</legend>
      </div>
    )

    if (section.is_conetent_first === "1") {
      return (
        <div key={`section_${i}`}>
          {photos}
          {parse(section.content)}
        </div>
      )
    } else {
      return (
        <div key={`section_${i}`}>
          {parse(section.content)}
          {photos}
        </div>
      )
    }
  }) || [];

  return (
    <div className="fadeIn">
      <BackButton title={store.articleDetails?.forward?.title} />
      <Container>
        {sections}
      </Container>
    </div>
  )
})

export default ArticlePage;